import clsx from 'clsx'
import { FC, useEffect, useState } from 'react'
import ARButton, { ARCapabilities } from './ARButton'
//@ts-ignore
import QRCode from 'qrcode'

import Drawer from '@components/ui/Drawer/drawer'
import { selectLabels } from '@redux/globalSlice'
import { useSelector } from 'react-redux'
import styles from './ARButtonWrapper.module.scss'

type ARButtonWrapperProps = {
  iosSrc?: string
  className?: string
  children?: React.ReactNode
}

const ARButtonWrapper: FC<ARButtonWrapperProps> = ({
  iosSrc,
  className,
  children,
}) => {
  const [popup, setPopup] = useState<boolean>(false)
  const [qrImageSrc, setQrImageSrc] = useState<string | null>(null)
  const [ARCapabilities, setARCapabilities] = useState<ARCapabilities>()

  const labels = useSelector(selectLabels)

  useEffect(() => {
    if (typeof window === 'undefined') return
    let origin = window.location.origin
    let href = window.location.href

    // replace localhost with 10.1.6.169
    if (origin.includes('localhost')) {
      origin = origin.replace('localhost', '192.168.210.29')
      href = href.replace('localhost', '192.168.210.29')
    }

    new Promise(async () => {
      setQrImageSrc(
        await QRCode.toDataURL(
          iosSrc?.replace(
            'https://d207q210x9tg6s.cloudfront.net/AR+files',
            `${origin}/arview/specific/page/`,
          ) + `?returnUrl=${encodeURIComponent(href)}`,
        ),
      )
    }).then(() => {})
  }, [])

  // https://d1ij5mhfn3p2nj.cloudfront.net/SVGs/ARIcon.svg

  return (
    <div
      className={clsx(styles.root, className, {
        [styles.active]: popup,
        [styles.shown]:
          ARCapabilities &&
          (ARCapabilities == 'UNSUPPORTED' ||
            ARCapabilities == 'IOS-QUICK-LOOK'),
      })}
    >
      <ARButton
        onInitialized={(capabilities) => setARCapabilities(capabilities)}
        arClickEvent={(event) => {
          if (event == 'UNSUPPORTED') setPopup((popup) => !popup)
        }}
        className={clsx(styles.button, `bodyText`)}
        iosSrc={iosSrc}
      >
        {children}
      </ARButton>

      <Drawer
        visible={popup}
        wrapClassName={styles.wrapper}
        onClose={() => setPopup(false)}
        closeIcon
      >
        <div className={clsx(styles.contentWrapper, styles.padded)}>
          <h3 className={styles.headline}>
            <span>AR-EXPERIENCE</span>
          </h3>
          <div className={styles.content}>
            <div className={styles.imageWrapper}>
              <img src={qrImageSrc} alt="QR Code" className={styles.image} />
            </div>
            <h4 className={styles.qrHeadline}>
              Use mobile camera to scan QR code
            </h4>
          </div>
          <div className={styles.footer}></div>
        </div>
      </Drawer>
    </div>
  )
}

export default ARButtonWrapper
// {popup && qrImageSrc && (
//   <div onClick={() => setPopup(false)} className={styles.popupBackground}>
//     <div className={styles.popup}>
//       <div onClick={() => setPopup(false)} className={styles.cross}></div>

//       <p className="bodyText text-center my-2">{labels.arQRCode}</p>
//       <div className="relative">
//         <img src={qrImageSrc} alt="QR Code" />
//         {/* <GubiAnimatedLogo color={'black'} width="4rem" /> */}
//       </div>
//     </div>
//   </div>
// )}
